import { render, staticRenderFns } from "./switchLedOneDialog.vue?vue&type=template&id=23788bcc&"
import script from "./switchLedOneDialog.vue?vue&type=script&lang=js&"
export * from "./switchLedOneDialog.vue?vue&type=script&lang=js&"
import style0 from "./switchLedOneDialog.vue?vue&type=style&index=0&id=23788bcc&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports